import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import i18n from 'i18n-js';
import { Box } from '@material-ui/core';
import { BaseModal } from 'components/UI';
import { FETCH_STATE } from 'constants/common';
import { useStyles } from './common.styles';
import { AccessDeviceActions } from 'state/modules/accessDevice';
import { NFCCardSelect } from 'components/AsyncFields';

export const AssignToUserNFCCardModal = ({ user, open, handleClick }) => {
  const classes = useStyles();
  const formRef = useRef(null);
  const dispatch = useDispatch();

  const { fetchingAccessDevice } = useSelector((state) => state.accessDevice);

  const NFCCardSchema = Yup.object().shape({
    access_device_id: Yup.string().required(i18n.t('common.required_field')),
    user_id: Yup.string()
      .required(i18n.t('common.required_field'))
      .typeError(i18n.t('common.required_field')),
  });

  const initialValues = {
    access_device_id: '',
    user_id: user?.id,
  };

  const onSubmit = (values) => {
    dispatch(AccessDeviceActions.assignAccessDevice(values));
  };

  const handleSubmit = () => {
    formRef.current.submitForm();
  };

  const loading = fetchingAccessDevice === FETCH_STATE.LOADING;

  const title = i18n.t('nfc.assign_nfc_to_user');

  return (
    <BaseModal
      size="sm"
      open={open}
      maxWidth={550}
      hasEnterButton
      onEnter={handleSubmit}
      handleClick={handleClick}
      enableCloseButton={true}
      title={title}
      enterButtonLabel={i18n.t('common.confirm')}
      loading={loading}
      data-cy="nfc-assign-to-user-modal"
    >
      <Box mt={1} mb={2} className={classes.assignNotes}>
        {i18n.t('nfc.assign_note')}
      </Box>
      <Box mt={1} mb={2} className={classes.statusLabelTitle}>
        {i18n.t('nfc.assign_ngc_to_user_description')}
      </Box>
      <Formik
        enableReinitialize
        innerRef={formRef}
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={NFCCardSchema}
      >
        {({ handleSubmit }) => {
          return (
            <Form noValidate onSubmit={handleSubmit}>
              <Box mt={1}>
                {open ? (
                  <Field
                    type="creators"
                    margin="none"
                    name="access_device_id"
                    id="access_device_id"
                    component={NFCCardSelect}
                    label={i18n.t('nfc.assign_search_by')}
                    customParams={{ status: 'UNASSIGNED' }}
                  />
                ) : null}
              </Box>
            </Form>
          );
        }}
      </Formik>
    </BaseModal>
  );
};

AssignToUserNFCCardModal.propTypes = {
  user: PropTypes.object,
  open: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default AssignToUserNFCCardModal;
